<template>
  <div>
    <v-card dark>
      <v-card-title>
        <v-icon x-large left>
          my_location
        </v-icon>
        <span class="title font-weight-light">Search</span>
      </v-card-title>
    </v-card>
    <v-container>
      <v-card-text
        ><h4>Search the Alberta Township System (ATS)</h4></v-card-text
      >
      <v-divider class="pb-4"></v-divider>
      <v-text-field
        clearable
        hint="Enter Meridian, Range, Township, and Section in the form: M-RR-TTT-SS"
        persistent-hint
        mask="#-##-###-##"
        v-model="searchQuery"
        label="5-23-063-26"
        solo
      ></v-text-field>
      <v-slide-y-transition>
        <div>
          <v-btn
            v-show="searchQuery && searchQuery.length === 8"
            color="info"
            @click="mapSearch()"
            ><v-icon>search</v-icon></v-btn
          >&nbsp;{{ collectingATS ? "Searching..." : "" }}
          <h3>{{ searchResultsText }}</h3>
          <v-progress-circular
            v-if="collectingATS"
            indeterminate
            size="50"
            color="info"
            class="progress-spinner"
          ></v-progress-circular>
        </div>
      </v-slide-y-transition>

      <v-card-text><h4>Search using Latitude and Longitude</h4></v-card-text>
      <v-divider class="pb-4"></v-divider>
      <v-layout>
        <v-flex sm12 md6>
          <v-text-field
            clearable
            hint="Enter a Latitude"
            persistent-hint
            number
            v-model="latSearch"
            label="53.8"
            solo
          ></v-text-field>
        </v-flex>
        <v-flex sm12 md6>
          <v-text-field
            clearable
            hint="Enter a Longitude"
            persistent-hint
            number
            v-model="lngSearch"
            label="-113.9"
            solo
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-slide-y-transition>
        <div>
          <v-btn
            v-show="latSearch && lngSearch"
            color="info"
            @click="latlngSearch()"
            ><v-icon>search</v-icon></v-btn
          >
        </div>
      </v-slide-y-transition>

      <v-card-text><h4>Search a Project on the Ground</h4></v-card-text>
      <v-divider></v-divider>
      <v-select
        label="Filter by Attribute"
        hint="Optional"
        persistent-hint
        v-model="attribute"
        :items="pogAttributes"
        clearable
      ></v-select>
      <v-text-field
        :hint="
          !pogAttrSearch
            ? 'Optional'
            : `${filteredPOGs.length} Project${
                filteredPOGs.length === 1 ? '' : 's'
              } found`
        "
        persistent-hint
        v-model="pogAttrSearch"
        clearable
        :disabled="!attribute"
        :placeholder="
          attribute ? `Filter by ${attribute}` : 'Select an Attribute'
        "
      ></v-text-field>
      <v-autocomplete
        v-model="pogSearch"
        :items="entriesNames"
        :search-input.sync="search"
        hide-no-data
        hide-selected
        placeholder="Project Name or ID"
        solo
        class="pt-4"
      ></v-autocomplete>
      <v-slide-y-transition>
        <div>
          <v-btn v-show="pogSearch" color="info" @click="searchPOG()"
            ><v-icon>search</v-icon></v-btn
          >
          <h3>{{ searchResultsText }}</h3>
        </div>
      </v-slide-y-transition>
    </v-container>
  </div>
</template>

<script>
import { getATS } from "@/api/map";

export default {
  name: "Search",

  props: {
    pogs: Array,
  },

  data() {
    return {
      searchQuery: null,
      latSearch: null,
      lngSearch: null,
      pogSearch: null,
      atsData: null,
      search: null,
      entries: [],
      searchResultsText: "",
      collectingATS: false,

      attribute: null,
      pogAttrSearch: null,
    };
  },

  computed: {
    entriesNames() {
      return this.entries
        .map((ent) => {
          return `${ent.name} (${ent.createdByUser} ${ent.id + 1})`;
        })
        .sort((a, b) => {
          let d1 = new Date(a.created);
          let d2 = new Date(b.created);
          return d2 - d1;
        });
    },
    pogAttributes() {
      return this.pogs.length > 0
        ? Object.keys(this.pogs[0]).filter(
            (key) => key !== "name" && key !== "id" && key != "userTransaction"
          )
        : [];
    },
    filteredPOGs() {
      if (this.attribute && this.pogAttrSearch) {
        let searchVal = this.pogAttrSearch.toLowerCase().replace(/ /g, "");
        return this.pogs.filter((pog) => {
          return JSON.stringify(pog[this.attribute])
            .toLowerCase()
            .replace(/ /g, "")
            .includes(searchVal);
        });
      } else {
        return this.pogs;
      }
    },
  },

  watch: {
    search() {
      this.updateEntries();
    },
    attribute() {
      this.pogAttrSearch = null;
      this.updateEntries();
    },
    pogAttrSearch() {
      this.updateEntries();
    },
  },

  methods: {
    moveToSearchCoords() {
      let ats = this.searchQuery;
      let twp = ats.slice(3, 6);
      if (twp[0] === "0") {
        twp = twp.slice(1);
      }
      try {
        let coords = this.atsData[ats[0]][ats.slice(1, 3)][twp][ats.slice(6)];
        // Add layer
        this.$emit("fly-to-marker", [coords.lng, coords.lat], 11);
        this.$emit("close");
      } catch (err) {
        this.searchResultsText = "Unable to find the provided location";
      }
    },
    mapSearch() {
      this.searchResultsText = "";
      if (!this.atsData) {
        this.collectingATS = true;
        getATS().then((response) => {
          this.atsData = response;
          this.moveToSearchCoords();
          this.collectingATS = false;
          this.$emit("close");
        });
      } else {
        this.moveToSearchCoords();
      }
    },
    latlngSearch() {
      try {
        let lngSearch = this.lngSearch;
        if (lngSearch[0] !== "-") lngSearch = "-" + lngSearch;

        this.$emit("close");
        // Add layer
        this.$emit("fly-to-marker", [lngSearch, this.latSearch], 10);
      } catch (err) {
        this.showMessage("Invalid Latitude and Longitude Coordinates", "red");
      }
    },
    searchPOG() {
      let pog = this.pogs.filter((ent) => {
        let entName = `${ent.name} (${ent.createdByUser} ${ent.id + 1})`;
        return entName === this.pogSearch;
      })[0];
      let coords = pog.coordinates;

      try {
        // Add layer
        this.$emit("fly-to-marker", [coords.lng, coords.lat], 12);
        this.$emit("close");
        this.entries = [];
        this.pogSearch = null;
      } catch (err) {
        this.searchResultsText = `Unable to find the Project ${this.pogSearch}`;
      }
    },
    updateEntries() {
      let foundPOGs;
      if (this.search) {
        let searchVal = this.search.toLowerCase().replace(/ /g, "");
        foundPOGs = this.filteredPOGs.filter((pog) => {
          return (
            pog.name
              .toLowerCase()
              .replace(/ /g, "")
              .includes(searchVal) ||
            `${pog.createdByUser.toLowerCase()}${pog.id + 1}`.includes(
              searchVal
            )
          );
        });
      } else foundPOGs = this.filteredPOGs;

      this.entries = foundPOGs;
    },
  },
};
</script>

<style scoped>
.progress-spinner {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 11;
}
</style>
